// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_comp.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse } from "./stcs_commons.entity";

export const protobufPackage = "stcs_cmw";

export interface CompByOrgListRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface CompGetRequest {
  ref_id_user: string;
  ref_id_comp: string;
}

export interface CompByUserListRequest {
  ref_id_user: string;
}

export interface CompCreateRequest {
  display_name: string;
  ref_id_user: string;
  ref_id_org: string;
  fpna_country: string;
  fpna_currency: string;
  fpna_fye_month: number;
  fpna_industry: number;
}

export interface CompDelRequest {
  ref_id_user: string;
  ref_id_comp: string;
}

export interface CompUpdateRequest {
  ref_id_user: string;
  ref_id_comp: string;
  fpna_country?: string | undefined;
  fpna_currency?: string | undefined;
  fpna_fye_month?: number | undefined;
  fpna_industry?: number | undefined;
  display_name?: string | undefined;
  fpna_name_origin?: string | undefined;
}

export interface CompUpdateI18nMapRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  i18n_map_key: string;
  label_map: { [key: string]: string };
}

export interface CompUpdateI18nMapRequest_LabelMapEntry {
  key: string;
  value: string;
}

function createBaseCompByOrgListRequest(): CompByOrgListRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const CompByOrgListRequest: MessageFns<CompByOrgListRequest> = {
  encode(message: CompByOrgListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompByOrgListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompByOrgListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompByOrgListRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: CompByOrgListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompByOrgListRequest>, I>>(base?: I): CompByOrgListRequest {
    return CompByOrgListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompByOrgListRequest>, I>>(object: I): CompByOrgListRequest {
    const message = createBaseCompByOrgListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseCompGetRequest(): CompGetRequest {
  return { ref_id_user: "", ref_id_comp: "" };
}

export const CompGetRequest: MessageFns<CompGetRequest> = {
  encode(message: CompGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(18).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: CompGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompGetRequest>, I>>(base?: I): CompGetRequest {
    return CompGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompGetRequest>, I>>(object: I): CompGetRequest {
    const message = createBaseCompGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseCompByUserListRequest(): CompByUserListRequest {
  return { ref_id_user: "" };
}

export const CompByUserListRequest: MessageFns<CompByUserListRequest> = {
  encode(message: CompByUserListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompByUserListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompByUserListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompByUserListRequest {
    return { ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "" };
  },

  toJSON(message: CompByUserListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompByUserListRequest>, I>>(base?: I): CompByUserListRequest {
    return CompByUserListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompByUserListRequest>, I>>(object: I): CompByUserListRequest {
    const message = createBaseCompByUserListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseCompCreateRequest(): CompCreateRequest {
  return {
    display_name: "",
    ref_id_user: "",
    ref_id_org: "",
    fpna_country: "",
    fpna_currency: "",
    fpna_fye_month: 0,
    fpna_industry: 0,
  };
}

export const CompCreateRequest: MessageFns<CompCreateRequest> = {
  encode(message: CompCreateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.display_name !== "") {
      writer.uint32(10).string(message.display_name);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(18).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(26).string(message.ref_id_org);
    }
    if (message.fpna_country !== "") {
      writer.uint32(42).string(message.fpna_country);
    }
    if (message.fpna_currency !== "") {
      writer.uint32(50).string(message.fpna_currency);
    }
    if (message.fpna_fye_month !== 0) {
      writer.uint32(56).uint32(message.fpna_fye_month);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(64).uint32(message.fpna_industry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompCreateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompCreateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_country = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_currency = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fpna_fye_month = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompCreateRequest {
    return {
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      fpna_country: isSet(object.fpna_country) ? globalThis.String(object.fpna_country) : "",
      fpna_currency: isSet(object.fpna_currency) ? globalThis.String(object.fpna_currency) : "",
      fpna_fye_month: isSet(object.fpna_fye_month) ? globalThis.Number(object.fpna_fye_month) : 0,
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
    };
  },

  toJSON(message: CompCreateRequest): unknown {
    const obj: any = {};
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.fpna_country !== "") {
      obj.fpna_country = message.fpna_country;
    }
    if (message.fpna_currency !== "") {
      obj.fpna_currency = message.fpna_currency;
    }
    if (message.fpna_fye_month !== 0) {
      obj.fpna_fye_month = Math.round(message.fpna_fye_month);
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompCreateRequest>, I>>(base?: I): CompCreateRequest {
    return CompCreateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompCreateRequest>, I>>(object: I): CompCreateRequest {
    const message = createBaseCompCreateRequest();
    message.display_name = object.display_name ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.fpna_country = object.fpna_country ?? "";
    message.fpna_currency = object.fpna_currency ?? "";
    message.fpna_fye_month = object.fpna_fye_month ?? 0;
    message.fpna_industry = object.fpna_industry ?? 0;
    return message;
  },
};

function createBaseCompDelRequest(): CompDelRequest {
  return { ref_id_user: "", ref_id_comp: "" };
}

export const CompDelRequest: MessageFns<CompDelRequest> = {
  encode(message: CompDelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(18).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompDelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompDelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompDelRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: CompDelRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompDelRequest>, I>>(base?: I): CompDelRequest {
    return CompDelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompDelRequest>, I>>(object: I): CompDelRequest {
    const message = createBaseCompDelRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

function createBaseCompUpdateRequest(): CompUpdateRequest {
  return {
    ref_id_user: "",
    ref_id_comp: "",
    fpna_country: undefined,
    fpna_currency: undefined,
    fpna_fye_month: undefined,
    fpna_industry: undefined,
    display_name: undefined,
    fpna_name_origin: undefined,
  };
}

export const CompUpdateRequest: MessageFns<CompUpdateRequest> = {
  encode(message: CompUpdateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(18).string(message.ref_id_comp);
    }
    if (message.fpna_country !== undefined) {
      writer.uint32(26).string(message.fpna_country);
    }
    if (message.fpna_currency !== undefined) {
      writer.uint32(34).string(message.fpna_currency);
    }
    if (message.fpna_fye_month !== undefined) {
      writer.uint32(40).int32(message.fpna_fye_month);
    }
    if (message.fpna_industry !== undefined) {
      writer.uint32(48).uint32(message.fpna_industry);
    }
    if (message.display_name !== undefined) {
      writer.uint32(58).string(message.display_name);
    }
    if (message.fpna_name_origin !== undefined) {
      writer.uint32(66).string(message.fpna_name_origin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompUpdateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompUpdateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fpna_country = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fpna_currency = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.fpna_fye_month = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fpna_name_origin = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompUpdateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      fpna_country: isSet(object.fpna_country) ? globalThis.String(object.fpna_country) : undefined,
      fpna_currency: isSet(object.fpna_currency) ? globalThis.String(object.fpna_currency) : undefined,
      fpna_fye_month: isSet(object.fpna_fye_month) ? globalThis.Number(object.fpna_fye_month) : undefined,
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : undefined,
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : undefined,
      fpna_name_origin: isSet(object.fpna_name_origin) ? globalThis.String(object.fpna_name_origin) : undefined,
    };
  },

  toJSON(message: CompUpdateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.fpna_country !== undefined) {
      obj.fpna_country = message.fpna_country;
    }
    if (message.fpna_currency !== undefined) {
      obj.fpna_currency = message.fpna_currency;
    }
    if (message.fpna_fye_month !== undefined) {
      obj.fpna_fye_month = Math.round(message.fpna_fye_month);
    }
    if (message.fpna_industry !== undefined) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    if (message.display_name !== undefined) {
      obj.display_name = message.display_name;
    }
    if (message.fpna_name_origin !== undefined) {
      obj.fpna_name_origin = message.fpna_name_origin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompUpdateRequest>, I>>(base?: I): CompUpdateRequest {
    return CompUpdateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompUpdateRequest>, I>>(object: I): CompUpdateRequest {
    const message = createBaseCompUpdateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.fpna_country = object.fpna_country ?? undefined;
    message.fpna_currency = object.fpna_currency ?? undefined;
    message.fpna_fye_month = object.fpna_fye_month ?? undefined;
    message.fpna_industry = object.fpna_industry ?? undefined;
    message.display_name = object.display_name ?? undefined;
    message.fpna_name_origin = object.fpna_name_origin ?? undefined;
    return message;
  },
};

function createBaseCompUpdateI18nMapRequest(): CompUpdateI18nMapRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", i18n_map_key: "", label_map: {} };
}

export const CompUpdateI18nMapRequest: MessageFns<CompUpdateI18nMapRequest> = {
  encode(message: CompUpdateI18nMapRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.i18n_map_key !== "") {
      writer.uint32(34).string(message.i18n_map_key);
    }
    Object.entries(message.label_map).forEach(([key, value]) => {
      CompUpdateI18nMapRequest_LabelMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompUpdateI18nMapRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompUpdateI18nMapRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.i18n_map_key = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = CompUpdateI18nMapRequest_LabelMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.label_map[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompUpdateI18nMapRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      i18n_map_key: isSet(object.i18n_map_key) ? globalThis.String(object.i18n_map_key) : "",
      label_map: isObject(object.label_map)
        ? Object.entries(object.label_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: CompUpdateI18nMapRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.i18n_map_key !== "") {
      obj.i18n_map_key = message.i18n_map_key;
    }
    if (message.label_map) {
      const entries = Object.entries(message.label_map);
      if (entries.length > 0) {
        obj.label_map = {};
        entries.forEach(([k, v]) => {
          obj.label_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompUpdateI18nMapRequest>, I>>(base?: I): CompUpdateI18nMapRequest {
    return CompUpdateI18nMapRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompUpdateI18nMapRequest>, I>>(object: I): CompUpdateI18nMapRequest {
    const message = createBaseCompUpdateI18nMapRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.i18n_map_key = object.i18n_map_key ?? "";
    message.label_map = Object.entries(object.label_map ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseCompUpdateI18nMapRequest_LabelMapEntry(): CompUpdateI18nMapRequest_LabelMapEntry {
  return { key: "", value: "" };
}

export const CompUpdateI18nMapRequest_LabelMapEntry: MessageFns<CompUpdateI18nMapRequest_LabelMapEntry> = {
  encode(message: CompUpdateI18nMapRequest_LabelMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompUpdateI18nMapRequest_LabelMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompUpdateI18nMapRequest_LabelMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompUpdateI18nMapRequest_LabelMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: CompUpdateI18nMapRequest_LabelMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompUpdateI18nMapRequest_LabelMapEntry>, I>>(
    base?: I,
  ): CompUpdateI18nMapRequest_LabelMapEntry {
    return CompUpdateI18nMapRequest_LabelMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompUpdateI18nMapRequest_LabelMapEntry>, I>>(
    object: I,
  ): CompUpdateI18nMapRequest_LabelMapEntry {
    const message = createBaseCompUpdateI18nMapRequest_LabelMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

export interface StcsWappSvcComp {
  comp_by_org_list(
    request: DeepPartial<CompByOrgListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_by_user_list(
    request: DeepPartial<CompByUserListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_create(request: DeepPartial<CompCreateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  comp_delete(request: DeepPartial<CompDelRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  comp_get(request: DeepPartial<CompGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  comp_update(request: DeepPartial<CompUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  comp_update_i18n_map(
    request: DeepPartial<CompUpdateI18nMapRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcCompClientImpl implements StcsWappSvcComp {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.comp_by_org_list = this.comp_by_org_list.bind(this);
    this.comp_by_user_list = this.comp_by_user_list.bind(this);
    this.comp_create = this.comp_create.bind(this);
    this.comp_delete = this.comp_delete.bind(this);
    this.comp_get = this.comp_get.bind(this);
    this.comp_update = this.comp_update.bind(this);
    this.comp_update_i18n_map = this.comp_update_i18n_map.bind(this);
  }

  comp_by_org_list(
    request: DeepPartial<CompByOrgListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_by_org_listDesc, CompByOrgListRequest.fromPartial(request), metadata);
  }

  comp_by_user_list(
    request: DeepPartial<CompByUserListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_by_user_listDesc, CompByUserListRequest.fromPartial(request), metadata);
  }

  comp_create(request: DeepPartial<CompCreateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_createDesc, CompCreateRequest.fromPartial(request), metadata);
  }

  comp_delete(request: DeepPartial<CompDelRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_deleteDesc, CompDelRequest.fromPartial(request), metadata);
  }

  comp_get(request: DeepPartial<CompGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_getDesc, CompGetRequest.fromPartial(request), metadata);
  }

  comp_update(request: DeepPartial<CompUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcCompcomp_updateDesc, CompUpdateRequest.fromPartial(request), metadata);
  }

  comp_update_i18n_map(
    request: DeepPartial<CompUpdateI18nMapRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompcomp_update_i18n_mapDesc,
      CompUpdateI18nMapRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcCompDesc = { serviceName: "stcs_cmw.StcsWappSvcComp" };

export const StcsWappSvcCompcomp_by_org_listDesc: UnaryMethodDefinitionish = {
  methodName: "comp_by_org_list",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompByOrgListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_by_user_listDesc: UnaryMethodDefinitionish = {
  methodName: "comp_by_user_list",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompByUserListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_createDesc: UnaryMethodDefinitionish = {
  methodName: "comp_create",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompCreateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_deleteDesc: UnaryMethodDefinitionish = {
  methodName: "comp_delete",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompDelRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_get",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_updateDesc: UnaryMethodDefinitionish = {
  methodName: "comp_update",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompUpdateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompcomp_update_i18n_mapDesc: UnaryMethodDefinitionish = {
  methodName: "comp_update_i18n_map",
  service: StcsWappSvcCompDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompUpdateI18nMapRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
